module.exports = __webpack_public_path__ + "img/shutterstock_105293906.66bf39a2.jpg";